import { ApplicationState } from '../../reducers';
import { ManualOverwritesMap } from '../../../types/custom_fields';

export const getManualOverwrites = (state: ApplicationState): ManualOverwritesMap => {
  return state.customFieldManualOverwrites?.manualOverwrites || {};
};

export const isManuallyOverridden = (
  state: ApplicationState,
  customFieldId: number,
  itemId: number
): boolean => {
  const manualOverwrites = getManualOverwrites(state);
  const itemIds = manualOverwrites[customFieldId] || [];
  return itemIds.includes(itemId);
};
